import React from 'react'
import { CircularProgress } from '@mui/material'
const ProgressModal = ({ title, progress }) => (
  <div className="flex flex-col items-center justify-center w-full !py-5">
    <div className="flex  flex-col md:flex-row items-center justify-center md:gap-4 gap-8">
      <CircularProgress color="inherit" size="30px" style={{ color: '#000' }} />
      <p className="text-sm font-bold text-center md:text-left">{title}</p>
    </div>
    <div className="mt-6 h-3 justify-start flex rounded-2xl bg-black opacity-10">
      <div
        style={{
          width: progress,
        }}
        className="bg-black rounded-2xl"
      ></div>
    </div>
  </div>
)

export default ProgressModal
